import {
    LOAD_ABOUT_DATA_FAIL,
    LOAD_ABOUT_DATA_FAIL_ACTION,
    LOAD_ABOUT_DATA_REQUEST,
    LOAD_ABOUT_DATA_REQUEST_ACTION,
    LOAD_ABOUT_DATA_SUCCESS,
    LOAD_ABOUT_DATA_SUCCESS_ACTION,
} from './actions';
import api from '@/redux/api/page';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { handleActions } from 'redux-actions';

export interface State {}

export const DEFAULT_STATE: State = {};

export const reducer = handleActions({}, DEFAULT_STATE);

/* SELECTORS */
const stateSelector = (state: GlobalState): State => state.about;

const shouldFetchAboutData = createSelector(stateSelector, () => true);

/* ACTION CREATORS */
const loadAboutData = () => async (dispatch, getState) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);

        dispatch({
            type: LOAD_ABOUT_DATA_REQUEST,
        } as LOAD_ABOUT_DATA_REQUEST_ACTION);

        const response = await api.fetchAboutData({ deployment });
        return dispatch({
            meta: { actionTime: Date.now() },
            payload: response.data,
            type: LOAD_ABOUT_DATA_SUCCESS,
        } as LOAD_ABOUT_DATA_SUCCESS_ACTION);
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: LOAD_ABOUT_DATA_FAIL,
        } as LOAD_ABOUT_DATA_FAIL_ACTION);
    }
};

export const fetchAboutDataIfNeeded = () => async (dispatch: Function, getState: Function) => {
    if (shouldFetchAboutData(getState())) {
        return dispatch(loadAboutData());
    }
    return Promise.resolve();
};
